const Footer = () => {
   return (
      <>
         <section className="SocialSec">
            <div className="container container-cus1190">
               <div className="SocBox">
                  <div>
                     <h2>Feel free the <span>keep in touch</span> </h2>
                  </div>
                  <div className="SocialIcn">
                     <a href="https://www.facebook.com/profile.php?id=61575073350958" target="_blank">
                        <img src={require("../../../assets/images/sc1.png")} className="img-fluid" alt="" />
                     </a>
                     <a href="https://x.com/Routine_Coin" target="_blank">
                        <img src={require("../../../assets/images/sc2.png")} className="img-fluid" alt="" />
                     </a>
                     <a href="https://www.youtube.com/@RoutineCoinn" target="_blank">
                        <img src={require("../../../assets/images/sc3.png")} className="img-fluid" alt="" />
                     </a>
                     <a href="https://t.me/routinecoin" target="_blank">
                        <img src={require("../../../assets/images/sc4.png")} className="img-fluid" alt="" />
                     </a>
                  </div>
               </div>
            </div>

         </section>
         <footer className=" indfooter">
            <div className="container container-cus1190">
               <div className="row">
                  <div className="col-xl-8">
                     <div className="row justify-content-between ">
                        <div className="col-6 col-lg-4">
                           <div className="ftmenulist">
                              <h5>Ecosystem</h5>
                              <ul>
                                 <li><a href="https://shop.rou-community.com/" target="_blank">Doroutine </a></li>
                                 <li><a href="https://www.billroutine.com/" target="_blank">Billroutine </a></li>
                                 <li><a href="https://doplantrip.com/" target="_blank">Doplantrip</a></li>
                              </ul>
                           </div>
                        </div>
                        <div className="col-6 col-lg-4">
                           <div className="ftmenulist">
                              <h5>Documentations</h5>
                              <ul>
                                 <li><a href="https://github.com/Routinecoin/RoutineCoin-Whitepaper">Whitepaper</a></li>
                                 <li><a href="https://github.com/Routinecoin/routinecoin">Github </a></li>
                                 <li><a href="https://polygonscan.com/token/0xCC44674022a792794d219847362bB95c661937A9" target="_blank">Smart Contract</a></li>
                              </ul>
                           </div>
                        </div>


                     </div>
                  </div>
                  <div className="col-xl-4">
                     <div className="ftmenulist text-xl-right">
                        <h4>support@routinecoin.info</h4>
                        <p>
                           Routine Coin (ROU) drives a sustainable ecosystem, integrating crypto into daily life
                           through Smart Mining and decentralized finance (DeFi) solution
                        </p>

                     </div>
                  </div>
               </div>
            </div>
            <div className="Copyrightcd ndmt-38 text-center">
               <div className="container container-cus1190">
                  <div className="FlxAre">
                     <p>© Copyright 2025 ROU. All Rights Reserved</p>
                     <div className="menuCopyrightcd">
                        <a href="">Usages Policy</a>
                        <a href="">Terms & Conditions</a>
                        <a href="">Privacy Policy</a>
                     </div>
                  </div>
               </div>
            </div>
         </footer>
      </>
   )
}
export default Footer;